<template>
  <div class="crancy-wc__footer--top">
    <div class="crancy-wc__footer">
      <ul class="crancy-wc__footer--list list-none">
        <li><a target="_blank" href="https://coinsnap.io/en/general-terms-and-conditions/"></a></li>
        <li><a target="_blank" href="https://coinsnap.io/en/privacy/">{{ $t("Privacy Policy") }}</a></li>
        <li><a target="_blank" href="https://coinsnap.io/en/coinsnap-support-request/">{{ $t("Help") }}</a></li>
      </ul>
      <div class="crancy-wc__footer--languages">
        <select v-model="language" class="crancy-wc__footer--language">
          <option value="en" selected>English</option>
          <option value="de">German</option>
          <option value="es">Spanish</option>
          <option value="fr">French</option>
        </select>

      </div>
    </div>
    <p class="crancy-wc__footer--copyright">
      @ {{ currentYear }} <a target="_blank" href="https://coinsnap.io">Coinsnap.</a> {{ $t("All Right Reserved") }}.
    </p>
  </div>
</template>

<script>

import {getCookie} from "@/assets/js/sharedFunctions";

export default {
  name: "FooterLogin",
  data() {
    return {
      language: "",
      currentYear: new Date().getFullYear(),
    }
  },
  watch: {
    language(newVal) {
      if (newVal === "en" || newVal === "de" || newVal === "es" || newVal === "fr") {
        this.$i18n.locale = newVal;
        let expirationDate = new Date();
        expirationDate.setTime(expirationDate.getTime() + (365 * 24 * 60 * 60 * 1000));
        document.cookie = `coinsnap-i18n=${newVal} expires=${expirationDate.toUTCString()}; path=/`
      }
    }
  },
  mounted() {
    const languageCookie = getCookie("coinsnap-i18n")?.split(" expires")[0]?.replace(/\s+/g, '')
    if (languageCookie) this.language = languageCookie
  },
};
</script>
